import(/* webpackMode: "eager" */ "/home/kehutanan-web/kehutanan-web/node_modules/next/dist/client/app-dir/link.js");
